import { render } from "./AutorisationParentale.vue?vue&type=template&id=4509d16a"
import script from "./AutorisationParentale.vue?vue&type=script&lang=js"
export * from "./AutorisationParentale.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__